import {enUS as enLocale, fr as frLocale} from 'date-fns/locale';
import i18n from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import {initReactI18next} from 'react-i18next';

import {IS_CAR} from '@app/env';
import en from '@shared/langs/en.json';
import fr from '@shared/langs/fr.json';

export enum Locales {
    en = 'en',
    fr = 'fr',
}

export const LocaleNames: Record<string, {name: string}> = {
    en: {name: 'English'},
    ...(IS_CAR && {fr: {name: 'French'}}),
};

export const locales: {[id: string]: Locale} = {
    [Locales.en]: enLocale,
    [Locales.fr]: frLocale,
};

const resources = {
    en: {translation: en},
    fr: {translation: fr},
};

i18n.use(LanguageDetector)
    .use(initReactI18next)
    .init({
        resources,
        fallbackLng: 'en',
        supportedLngs: ['en', 'fr'],
        nonExplicitSupportedLngs: true,
        interpolation: {escapeValue: false},
    });

export default i18n;
